import axios from "axios";
import { apiBaseUrl } from "../config/runtime";
import { getClientRequestId, trackException } from "../observability/telemetry";
// Keycloak disabled for now.
// import {
//   clearSession,
//   ensureFreshAccessToken,
// } from "./keycloakSession";

const API = axios.create({
  baseURL: apiBaseUrl,
});

const getStoredToken = () => {
  const rawSession = localStorage.getItem("admin.session");

  if (rawSession) {
    try {
      return JSON.parse(rawSession)?.token || null;
    } catch (error) {
      return null;
    }
  }

  return localStorage.getItem("token");
};

const clearStoredSession = () => {
  localStorage.removeItem("admin.session");
  localStorage.removeItem("token");
};

API.interceptors.request.use(async (config) => {
  // Keycloak disabled for now.
  // const token = await ensureFreshAccessToken();
  const token = getStoredToken();
  const requestId = getClientRequestId();

  config.headers = config.headers || {};
  config.headers["x-request-id"] = requestId;

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const requestId =
      error.response?.headers?.["x-request-id"] ||
      error.config?.headers?.["x-request-id"] ||
      null;
    const traceId = error.response?.headers?.["x-trace-id"] || null;

    error.requestId = requestId;
    error.traceId = traceId;

    if (error.response) {
      error.response.requestId = requestId;
      error.response.traceId = traceId;
    }

    trackException(error, {
      source: "api.client",
      requestId: requestId || "",
      traceId: traceId || "",
      status: String(status || ""),
      method: error.config?.method || "",
      url: error.config?.url || "",
    });

    // Only an unusable session (401) ends the session. A 403 means the token is
    // valid but the role may not do this, which is an expected outcome now that
    // plan_admin is scoped - signing the user out there would be wrong.
    if (status === 401) {
      // Keycloak disabled for now.
      // clearSession();
      clearStoredSession();
      if (window.location.pathname !== "/signin") {
        window.location.assign("/signin");
      }
    }

    return Promise.reject(error);
  }
);

export default API;
